import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import cellStyles from "@components/history/views/cells/Cell.module.scss";
import { OrganizationActivityRow } from "../organizationActivityRow";
import { getOrganizationActivityRowDescriptionParts } from "../describeOrganizationActivity";

export const ActionCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, OrganizationActivityRow, unknown>) => {
        const { prefix, counter, suffix } =
            getOrganizationActivityRowDescriptionParts(row.original);

        return (
            <ViewTableCell className={cellStyles.activityCell}>
                {prefix && <span>{prefix}</span>}
                {counter && (
                    <span className={cellStyles.counter}> {counter}</span>
                )}
                {suffix && <span> {suffix}</span>}
            </ViewTableCell>
        );
    },
);

ActionCell.displayName = "ActionCell";
